const selectors = {
  getBIRaports: state => state.biRaports.get('allRaports'),
  getBICompositionRaports: state => state.biRaports.get('compositionBIRaports'),
  getPublishedRaports: state => state.biRaports.get('publishedBIRaports')
};

export default selectors;
